<template>
  <base-button
    icon
    :tooltip="$t('common.changeTheme')"
    @click="$vuetify.theme.dark = !$vuetify.theme.dark"
  >
    <v-icon>mdi-theme-light-dark</v-icon>
  </base-button>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  data: (vm) => ({}),
  methods: {},
}
</script>

<style></style>
